// extracted by mini-css-extract-plugin
module.exports = {"link":"vs3cw","ButtonLiftedShadow":"_2u3pr","buttonLiftedShadow":"_2u3pr","label":"_1P70s","shd":"_1sxAA","left":"_3C8En","right":"_1efmp"};